module.exports = __webpack_public_path__ + "static/media/Avante-01.7c37ee20.svg";